import moment from 'moment';
import {IntlShape} from 'react-intl';

export const notAvailable = (intl: IntlShape) => intl.formatMessage({id: 'notAvailable'});

export const orNotAvailable = (intl: IntlShape, text: string | null | undefined) => text || notAvailable(intl);

export const formatDateTime = (intl: IntlShape, value: string | null | undefined) => (
  value ? moment(value).format(intl.formatMessage({id: 'dateTimeLongFormat'})) : notAvailable(intl)
);
